<template>
  <div id="contenedor-eliminar-usuario">
    <v-card>
      <v-card-title class="secondary--text">
        Eliminar Usuario
      </v-card-title>
      <v-card-text>
        ¿Desea eliminar al usuario "{{ usuarioEliminar.correoElectronico }}"?
      </v-card-text>
      <v-divider class="bkground" />
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button
          @click="cerrar"
          tipo="formCancelar"
          label="Cancelar"
          class="mr-3">
        </custom-button>
        <custom-button
          @click="mixEliminarUsuario"
          :disabled="enviandoFormulario"
          :loading="enviandoFormulario"
          tipo="formAceptar"
          label="Eliminar">
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import mixCatalogoUsuarios from './mixCatalogoUsuarios';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'EliminarUsuario',
  mixins: [mixCatalogoUsuarios],
  props: {
    usuarioEliminar: Object,
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      enviandoFormulario: false,
    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
      this.mostrarDialogo = false;
    },
  },
};
</script>

<style>
</style>
